import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class ConfigurationService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    getConfigurationByCode(code) {
        const userid = sessionStorage.getItem('userid');
        //const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/configuration/values?code=${code}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    updateConfiguracion(config) {
        const userid = sessionStorage.getItem('userid');
        const body = JSON.stringify({ config });
        return this.http.post(`${this.configService.API_URL}/configuration/`, body.replace('{"config":', '').slice(0, -1), Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getAllConfiguraciones() {
        const userid = sessionStorage.getItem('userid');
        //const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/configuration/obtener-configuraciones`, Object.assign({}, this.jsonContent)).toPromise();
    }
    deletePlanificacion(idPlanificacion) {
        const userid = sessionStorage.getItem('userid');
        const body = JSON.stringify({ idPlanificacion: idPlanificacion });
        return this.http.post(`${this.configService.API_URL}/configuration/delete-configuration`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(request) {
        const userid = sessionStorage.getItem('userid');
        return this.http.post(`${this.configService.API_URL}/configuration/create-configuration`, request, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    update(request) {
        const userid = sessionStorage.getItem('userid');
        return this.http.post(`${this.configService.API_URL}/configuration/update-configuration`, request, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
}
ConfigurationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigurationService_Factory() { return new ConfigurationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: ConfigurationService, providedIn: "root" });
